import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import FeatureLabel from './_components/FeatureLabel';
import { ReliabilityMetricsCastctlVersionAlert } from '../CastctlOnboardingDialog/ReliabilityMetricsCastctlVersionAlert';

type SetupProps = Pick<
  AgentSetupBlockProps,
  'checked' | 'onChange' | 'hasBeenInstalled' | 'showCheckbox'
> & {
  showVersionAlert?: boolean;
};

const heading = FEATURE_TO_TITLE.reliabilityMetrics;
const description =
  'Collect availability, request throughput, error rate, and latency metrics across your cluster and workloads.';

export const AgentReliabilitySetup = ({
  showVersionAlert,
  ...props
}: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description={description}
      isNestedBlock
      labelChip={<FeatureLabel type="new" />}
      testId="reliability-metrics"
      addon={
        showVersionAlert ? <ReliabilityMetricsCastctlVersionAlert /> : undefined
      }
      {...props}
    />
  );
};
